









































































































import * as R from "ramda";
import Vue from "vue";

import {Product} from "@/core/entity";

import CategoryInput from "@/vue/components/input/Category.vue";
import CountryInput from "@/vue/components/input/Country.vue";
import DesProductInput, {
  DesProduct,
} from "@/vue/components/input/DesProduct.vue";

import {getProductQL} from "./graphql";

export default Vue.extend({
  components: {
    "input-category": CategoryInput,
    "input-country": CountryInput,
    "input-des-product": DesProductInput,
  },

  props: {
    productId: String as () => string,
    loading: Boolean as () => boolean,
  },

  apollo: {
    product: {
      query: getProductQL,
      variables() {
        return {id: this.productId};
      },
      skip() {
        return !this.productId;
      },
      fetchPolicy: "cache-and-network",
    },
  },

  data() {
    return {
      brand: null as string | null,
      category: null as string | null,
      country: "my" as string | null,
      desProduct: null as DesProduct | null,
      initialDesProductId: null as string | null,
      name: null as string | null,
      product: null as Product | null,
    };
  },
  watch: {
    product(newVal: Product) {
      this.brand = newVal ? newVal.brand! : "";
      this.category = newVal ? newVal.category!.id : "";
      this.country = newVal ? newVal.country! : "";
      this.initialDesProductId = newVal ? newVal.desProductId! : null;
      this.name = newVal ? newVal.name! : "";
    },
  },

  methods: {
    clear() {
      this.brand = "";
      this.category = "";
      this.country = "";
      this.desProduct = null;
      this.initialDesProductId = null;
      this.name = "";
      this.product = null;
    },

    handleRemoveDesMapping() {
      this.$emit("submit", {
        brand: this.brand!,
        category: this.category!,
        country: this.country!,
        desProductId: null,
        photoUrl: null,
        name: this.name!,
      });
    },

    handleSubmit() {
      if (!this.country) {
        this.$message.error("Country is required!");
        return;
      }

      if (!this.name) {
        this.$message.error("Product name is required!");
        return;
      }

      if (!this.brand) {
        this.$message.error("Brand name is required!");
        return;
      }

      if (!this.category) {
        this.$message.error("Category is required!");
        return;
      }

      const desProductId = this.product ? this.product.desProductId : null;
      const photo = this.product ? this.product.photo : null;
      let photoUrl = photo ? photo.url : "";
      photoUrl = R.path(["photo", "small"], this.desProduct) || '';

      this.$emit("submit", {
        brand: this.brand!,
        category: this.category!,
        country: this.country!,
        desProductId: R.path(["id"], this.desProduct) || desProductId,
        photoUrl: photoUrl,
        name: this.name!,
      });
    },
  },
});
